/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/



(function() {
  // Add custom code below this line
 
  const CONTAINER = '.product-quick-add__form .radio__fieldset--swatches .radio__buttons';
  const ITEM_SEL = 'tooltip-component, .tooltip-component'; // por si tu tema usa clase
  const WRAP_CLASS = 'swatch-slider-wrapper';

  function getViewport(container){
    const inside = container.querySelector('.native-scrollbar');
    if (inside) return inside;
    const parent = container.closest('.native-scrollbar');
    if (parent) return parent;
    return container;
  }

  function ensureWrapper(container){
    if (container.parentElement && container.parentElement.classList.contains(WRAP_CLASS)) {
      return container.parentElement;
    }
    const wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;
    container.parentNode.insertBefore(wrap, container);
    wrap.appendChild(container);
    return wrap;
  }

  function enableDragScroll(viewport){
// Config básica para scroll táctil fluido
viewport.style.overflowX = viewport.style.overflowX || 'auto';
viewport.style.webkitOverflowScrolling = 'touch';
if (!viewport.style.touchAction) viewport.style.touchAction = 'pan-x';

let dragging = false;
let allowDrag = false;   // ← solo true para touch
let startX = 0;
let startScroll = 0;
const THRESHOLD = 6;

function cancelNextClickOnce(ev){
  ev.stopPropagation();
  ev.stopImmediatePropagation();
  ev.preventDefault();
  viewport.removeEventListener('click', cancelNextClickOnce, true);
}

const start = (e) => {
  // Bloquear drag si es mouse
  if (e.type === 'pointerdown' && e.pointerType !== 'touch') { allowDrag = false; return; }
  if (e.type === 'mousedown') { allowDrag = false; return; } // por si se llega a registrar

  // Touch start
  const p = e.clientX ?? (e.touches && e.touches[0]?.clientX) ?? 0;
  startX = p;
  startScroll = viewport.scrollLeft;
  dragging = false;
  allowDrag = true;
};

const move = (e) => {
  if (!allowDrag) return; // ignora mouse move

  const p = e.clientX ?? (e.touches && e.touches[0]?.clientX) ?? 0;
  const dx = p - startX;

  if (!dragging && Math.abs(dx) > THRESHOLD) {
    dragging = true;
    viewport.addEventListener('click', cancelNextClickOnce, true);
  }

  if (dragging) {
    viewport.scrollLeft = startScroll - dx;
    if (e.cancelable) e.preventDefault();
  }
};

const end = () => {
  dragging = false;
  allowDrag = false;
};

if (window.PointerEvent) {
  // Solo pointer events de tipo touch
  viewport.addEventListener('pointerdown', start, {passive:true});
  viewport.addEventListener('pointermove',  move,  {passive:false});
  viewport.addEventListener('pointerup',    end,   {passive:true});
  viewport.addEventListener('pointercancel',end,   {passive:true});
  viewport.addEventListener('pointerleave', end,   {passive:true});
} else {
  // Fallback iOS Safari: solo TouchEvents
  viewport.addEventListener('touchstart', start, {passive:true});
  viewport.addEventListener('touchmove',  move,  {passive:false});
  viewport.addEventListener('touchend',   end,   {passive:true});
  viewport.addEventListener('touchcancel',end,   {passive:true});
  // Intencionalmente SIN mousedown/mousemove
}
}

  function makeSlider(container){
    if (!container || container.dataset.sliderApplied === '1') return;

    const items = container.querySelectorAll(ITEM_SEL);
    if (items.length <= 5) return;

    const wrapper = ensureWrapper(container);
    container.classList.add('swatch-slider');
    container.dataset.sliderApplied = '1';

    const viewport = getViewport(container);
    // si usas la clase para ocultar scrollbar, mantenla
    viewport.classList.add('hide-scrollbar');

    // --- flechas (mantengo tus SVGs tal cual)
    let prev = wrapper.querySelector('.swatch-slider__arrow--prev');
    let next = wrapper.querySelector('.swatch-slider__arrow--next');
    if (!prev) {
      prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'swatch-slider__arrow swatch-slider__arrow--prev';
      prev.setAttribute('aria-label','Anterior');
      prev.innerHTML = '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 15L1 7.82927L9 1" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      wrapper.appendChild(prev);
    }
    if (!next) {
      next = document.createElement('button');
      next.type = 'button';
      next.className = 'swatch-slider__arrow swatch-slider__arrow--next';
      next.setAttribute('aria-label','Siguiente');
      next.innerHTML = '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L9 8.17073L1 15" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      wrapper.appendChild(next);
    }

    function stepSize(){
      const first = container.querySelector(ITEM_SEL);
      const w = first ? first.getBoundingClientRect().width : 80;
      return Math.max(60, Math.round(w * 2.5));
    }

    function updateArrows(){
      const max = viewport.scrollWidth - viewport.clientWidth;
      const sl  = Math.max(0, Math.min(viewport.scrollLeft, max));
      prev.disabled = sl <= 0;
      next.disabled = sl >= (max - 1);
      const show = max > 4;
      prev.style.display = show ? '' : 'none';
      next.style.display = show ? '' : 'none';
    }

    function scrollByX(dx){
      try{
        viewport.scrollBy({left: dx, behavior: 'smooth'});
      }catch(_){
        viewport.scrollLeft += dx;
      }
      requestAnimationFrame(updateArrows);
    }

    prev.addEventListener('click', ()=> scrollByX(-stepSize()));
    next.addEventListener('click', ()=> scrollByX( stepSize()));
    viewport.addEventListener('scroll', updateArrows, {passive:true});
    window.addEventListener('resize', updateArrows, {passive:true});

    // --- habilitar gesto táctil/drag
    enableDragScroll(viewport);

    requestAnimationFrame(updateArrows);
  }

  function scan(root=document){
    root.querySelectorAll(CONTAINER).forEach(makeSlider);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', ()=>scan());
  } else {
    scan();
  }

  const mo = new MutationObserver((muts)=>{
    for (const m of muts){
      for (const node of m.addedNodes){
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.(CONTAINER) || node.querySelector?.(CONTAINER)){
          scan(node);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });

  




  "use strict";

  const BTN_SEL = '[data-quick-add-variant][data-variant-id]';
  const HOLDER_SEL = '[data-quick-add-holder]';
  const FORM_CLASS = 'quick-add__variant-form';

  function ensureForm(holder) {
    let form = holder.querySelector(`form.${FORM_CLASS}`);
    if (form) return form;

    form = document.createElement('form');
    form.className = FORM_CLASS;
    form.method = 'post';
    form.action = (window.theme?.routes?.cart_add_url) || '/cart/add';
    form.enctype = 'multipart/form-data';
    form.style.display = 'none';

    const idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = '';

    const qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = '1';

    const submit = document.createElement('button');
    submit.type = 'submit';
    submit.setAttribute('data-variant-submit', '');
    submit.style.display = 'none';

    form.appendChild(idInput);
    form.appendChild(qtyInput);
    form.appendChild(submit);

    holder.appendChild(form);
    return form;
  }

  function setVariant(form, variantId) {
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = String(variantId);
  }

  function dispatchThemeAdd(submitButton) {
    // IMPORTANTE: no abrir drawer manualmente, el tema lo hace.
    document.dispatchEvent(
      new CustomEvent('theme:cart:add', {
        bubbles: true,
        detail: { button: submitButton }
      })
    );
  }

  function onClick(e) {
    const btn = e.target.closest(BTN_SEL);
    if (!btn) return;

    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    e.preventDefault();
    e.stopPropagation();

    const holder = btn.closest(HOLDER_SEL);
    if (!holder) return;

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    const form = ensureForm(holder);
    setVariant(form, variantId);

    const submit = form.querySelector('button[data-variant-submit]');
    if (!submit) return;

    // UI estado
    btn.classList.add('is-loading');
    btn.disabled = true;

    // Limpieza cuando tema responda
    const cleanup = () => {
      btn.classList.remove('is-loading');
      // si era soldout no lo re-habilites
      if (!btn.classList.contains('is-soldout')) btn.disabled = false;
      document.removeEventListener('theme:product:add', cleanup, true);
      document.removeEventListener('theme:product:add-error', cleanup, true);
    };
    document.addEventListener('theme:product:add', cleanup, true);
    document.addEventListener('theme:product:add-error', cleanup, true);

    dispatchThemeAdd(submit);
  }

  // Delegación
  document.addEventListener('click', onClick, true);



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.



  // Megamenu 

    const root = document.querySelector('[data-mm-attach]');
    if(!root) return;
  
    // Selectores fijos según tu header actual
    const navEl = document.querySelector('.header__menu');
    if(!navEl) return;
  
    const topLinks = Array.from(navEl.querySelectorAll('.navlink--toplevel'));
    const panels = Array.from(root.querySelectorAll('[data-mm-panel]'));
    const overlay = root.querySelector('[data-mm-overlay]');
  
    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
    const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  
    const findPanelByTitle = (title) => {
      const t = norm(title);
      return panels.find(p => norm(p.getAttribute('data-mm-match-title')) === t);
    };
  
    const setTopFromNav = () => {
      const r = navEl.getBoundingClientRect();
      root.style.setProperty('--mm-top', r.bottom + 'px');
    };
  
    const closeAll = () => {
      panels.forEach(p => {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden','true');
      });
      if(overlay) overlay.hidden = true;
    };
  
  
    const mm51_initTabsIn = (scopeEl) => {
      if(!scopeEl) return;
  
      const wrappers = Array.from(scopeEl.querySelectorAll('[data-mm-tabs]'));
      if(!wrappers.length) return;
  
      wrappers.forEach((wrap) => {
        // evita doble init
        if(wrap.getAttribute('data-mm-tabs-bound') === 'true') return;
        wrap.setAttribute('data-mm-tabs-bound', 'true');
  
        const btns = Array.from(wrap.querySelectorAll('[data-mm-tab-btn]'));
        const tabPanels = Array.from(wrap.querySelectorAll('[data-mm-tab-panel]'));
        if(!btns.length || !tabPanels.length) return;
  
        const setActive = (key) => {
          btns.forEach((b) => {
            const isOn = b.getAttribute('data-mm-tab-btn') === key;
            b.classList.toggle('is-active', isOn);
            b.setAttribute('aria-selected', isOn ? 'true' : 'false');
          });
  
          tabPanels.forEach((p) => {
            const isOn = p.getAttribute('data-mm-tab-panel') === key;
            p.classList.toggle('is-active', isOn);
          });
        };
  
        const def =
          wrap.getAttribute('data-default-tab') ||
          (btns[0] ? btns[0].getAttribute('data-mm-tab-btn') : null);
  
        if(def) setActive(def);
  
        btns.forEach((btn) => {
          btn.addEventListener('click', () => {
            setActive(btn.getAttribute('data-mm-tab-btn'));
          });
        });
      });
    };
  
    // --- Colección → imagen (desde template collection.mm.liquid) ---
    const collectionDataCache = new Map();
  
    const getCollectionHandleFromUrl = (url) => {
      try {
        const u = new URL(url, window.location.origin);
        const m = u.pathname.match(/^\/collections\/([^\/?#]+)/i);
        return m ? m[1] : null;
      } catch (e) {
        return null;
      }
    };
  
    const fetchCollectionData = async (handle) => {
      if(collectionDataCache.has(handle)) return collectionDataCache.get(handle);
  
      const res = await fetch(`/collections/${handle}?view=mm`, { credentials: 'same-origin' });
      if(!res.ok) throw new Error('collection mm view not found');
      const data = await res.json();
      collectionDataCache.set(handle, data);
      return data;
    };
  
    const fillLeftFromTriggerHref = async (panel, href, title) => {
      const mainLink = panel.querySelector('[data-mm-main-link]');
      const mainCta  = panel.querySelector('[data-mm-main-cta]');
      const imgEl    = panel.querySelector('[data-mm-main-img]');
  
      if(mainLink) mainLink.href = href || '#';
      if(mainCta)  mainCta.href = href || '#';
      if(mainCta)  mainCta.textContent = 'Ir a la colección';
  
      if(!imgEl) return;
  
      imgEl.hidden = true;
      imgEl.removeAttribute('src');
      imgEl.alt = (title || '').trim();
  
      const handle = getCollectionHandleFromUrl(href || '');
      if(!handle) return; // si no es /collections/..., no mostramos imagen
  
      try {
        const data = await fetchCollectionData(handle);
        if(data && data.image) {
          imgEl.src = data.image;
          imgEl.hidden = false;
        }
      } catch(e) {
        // si falla, simplemente no mostramos imagen
      }
    };
  
    let closeTimer = null;
    const cancelClose = () => { clearTimeout(closeTimer); closeTimer = null; };
    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 120);
    };
  
    const openForTrigger = async (a) => {
      const title = a.querySelector('.navtext') ? a.querySelector('.navtext').textContent : a.textContent;
      const href = a.getAttribute('href') || '#';
  
      const panel = findPanelByTitle(title);
      if(!panel) { closeAll(); return; }
  
      closeAll();
      setTopFromNav();
  
      // título del panel
      const titleEl = panel.querySelector('[data-mm-title]');
      if(titleEl) titleEl.textContent = (title || '').trim();
  
      // rellena izquierda (link + imagen de colección si aplica)
      await fillLeftFromTriggerHref(panel, href, title);
  
      // inicializa tabs (solo dentro de este panel)
      mm51_initTabsIn(panel);
  
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden','false');
      if(overlay) overlay.hidden = false;
    };
  
    // binds
    topLinks.forEach(a => {
      if(a.getAttribute('data-mm-bound') === 'true') return;
      a.setAttribute('data-mm-bound', 'true');
  
      a.addEventListener('mouseenter', () => {
        if(!isDesktop()) return;
        cancelClose();
        openForTrigger(a);
      });
  
      a.addEventListener('focus', () => {
        if(!isDesktop()) return;
        cancelClose();
        openForTrigger(a);
      });
  
      a.addEventListener('mouseleave', () => {
        if(!isDesktop()) return;
        scheduleClose();
      });
    });
  
    panels.forEach(p => {
      p.addEventListener('mouseenter', () => { if(!isDesktop()) return; cancelClose(); });
      p.addEventListener('mouseleave', () => { if(!isDesktop()) return; scheduleClose(); });
    });
  
    navEl.addEventListener('mouseleave', () => { if(!isDesktop()) return; scheduleClose(); });
    if(overlay) overlay.addEventListener('click', closeAll);
  
    document.addEventListener('keydown', (e) => { if(e.key === 'Escape') closeAll(); });
  
    window.addEventListener('resize', () => {
      if(!isDesktop()) closeAll();
      setTopFromNav();
    }, { passive: true });
  
    window.addEventListener('scroll', () => {
      if(!isDesktop()) return;
      setTopFromNav();
    }, { passive: true });
  
    setTopFromNav();

})();
